export default __webpack_public_path__ + "static/media/weather_tile.a6bf467e.png";